import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDeleteGoodsPayload, IUpdateGoodsPayload, TGoodsStore } from './types';

const initialState: TGoodsStore = {
	goodsLoading: false,
	goodsError: null,
	deleteGoodsLoading: false,
	deleteGoodsError: null,
};

const goods = createSlice({
	name: '@goods',
	initialState,
	reducers: {
		updateGoodsRequest: (state, action: PayloadAction<IUpdateGoodsPayload>) => {
			const goodsState = state;
			goodsState.goodsLoading = true;
			goodsState.goodsError = null;
		},
		updateGoodsSuccess: (state) => {
			const goodsState = state;
			goodsState.goodsLoading = false;
			goodsState.goodsError = null;
		},
		updateGoodsFailure: (state, action: PayloadAction<string>) => {
			const goodsState = state;
			goodsState.goodsLoading = false;
		},
		deleteGoodsRequest: (state, action: PayloadAction<IDeleteGoodsPayload>) => {
			const goodsState = state;
			goodsState.deleteGoodsLoading = true;
		},
		deleteGoodsSuccess: (state) => {
			const goodsState = state;
			goodsState.deleteGoodsLoading = false;
		},
	},
});

export const {
	updateGoodsRequest,
	updateGoodsSuccess,
	updateGoodsFailure,
	deleteGoodsRequest,
	deleteGoodsSuccess,
} = goods.actions;
export default goods.reducer;
